export default "__VITE_ASSET__B0fBlb1W__"